import { render, staticRenderFns } from "./CollectionFilter.vue?vue&type=template&id=4a8da4d4"
import script from "./CollectionFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports